import { MutationTree } from 'vuex'
import {
  DeadlinesState,
  Deadline,
} from '@/store/deadlines/types'
import _ from 'lodash'
import { Pager } from '@/store/pager.types'

const mutations: MutationTree<DeadlinesState> = {
  fetchedDeadlines: (state: DeadlinesState, payload: {
    pager: Pager,
    deadlines: Deadline[],
  }) => {
    state.pager = payload.pager
    state.deadlines = payload.deadlines
  },

  fetchedDeadlinesOfEach: (state: DeadlinesState, payload: {
    pager: Pager,
    deadlines: Deadline[],
    index: number,
  }) => {
    const each = _.cloneDeep(state.each)
    each[payload.index] = {
      pager: payload.pager,
      deadlines: payload.deadlines,
    }
    state.each = each
  },

  gotDeadline: (state: DeadlinesState, deadline: Deadline) => {
    state.deadlines = _.uniqBy([
      deadline,
      ...state.deadlines,
    ], 'id')
  },
}

export default mutations
